import { createSelector } from 'reselect'
import { getAlarmsRaw } from './alarms'
import { getInactivityAlarmsRaw } from './inactivityAlarms'

const toAlarmArray = alarms => (alarms ? alarms.valueSeq().toArray() : [])

export const getParameterAlarmConstraints = createSelector([getAlarmsRaw], alarms => {
  const paramsBySystem = {}

  toAlarmArray(alarms).forEach(alarm => {
    const deviceIds = alarm.get('DeviceIds') || []
    const meta = alarm.get('Meta')
    const alarmParams = meta ? meta.keySeq().toArray() : []

    deviceIds.forEach(systemId => {
      if (!paramsBySystem[systemId]) {
        paramsBySystem[systemId] = []
      }
      paramsBySystem[systemId].push(alarmParams)
    })
  })

  return paramsBySystem
})

export const getInactivityAlarmSystems = createSelector([getInactivityAlarmsRaw], alarms => {
  const inactivityAlarmSystems = {}

  toAlarmArray(alarms).forEach(alarm => {
    const devices = alarm.get('Devices')
    const deviceIds = devices ? devices.keySeq().toArray() : []

    deviceIds.forEach(systemId => {
      inactivityAlarmSystems[systemId] = true
    })
  })

  return inactivityAlarmSystems
})
